export const ROOM = 'room';
export const CHARACTER = 'character';
export const SHOWER = 'shower';

export const SHOP_TYPES = {
  [ROOM]: ['Furniture', 'FloorWall'],
  [CHARACTER]: ['Clothes', 'Head'],
  [SHOWER]: ['Shower'],
};
